import { node } from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { Trans } from '@lingui/macro';

import Link from '../links/Link';
import { useIsSysAdminUser } from '../../stores/SessionStore';
import { useSMTPEnabled } from '../../stores/EnvironmentStore';

const useStyles = makeStyles((theme) => ({
    smtpCenterItems: {
        ...theme.mixins.flex.displayFlex,
        ...theme.mixins.flex.flexDirectionRow,
        ...theme.mixins.flex.justifyContentCenter,
        width: '100%',
    },
    smtpMessage: {
        ...theme.mixins.flex.displayFlex,
        ...theme.mixins.flex.flexDirectionRow,
        ...theme.mixins.flex.alignItemsCenter,
        '& svg': {
            fontSize: 28,
            color: theme.palette.alert.info,
            marginRight: theme.spacing(1.5),
        },
    },
    smtpLink: {
        marginTop: theme.spacing(2),
    },
}));

export default function NgpSmtpGuard({ children, message }) {
    const classes = useStyles();
    const [smtpEnabled] = useSMTPEnabled();
    const [isSysAdminUser] = useIsSysAdminUser();

    const theMessage = message || (
        <Trans>The SMTP server will need to be configured for this functionality to work</Trans>
    );

    return smtpEnabled ? (
        children
    ) : (
        <>
            <div className={classes.smtpCenterItems}>
                <div className={classes.smtpMessage}>
                    <div>
                        <InfoOutlinedIcon />
                    </div>
                    <div>{theMessage}</div>
                </div>
            </div>
            <div className={`${classes.smtpCenterItems} ${classes.smtpLink}`}>
                <div>
                    {isSysAdminUser ? (
                        <Link to="/admin/config">
                            <Trans>Go to SMTP Configuration</Trans>
                        </Link>
                    ) : (
                        <Typography variant="caption">
                            <Trans>Contact your system administrator to configure an SMTP server</Trans>
                        </Typography>
                    )}
                </div>
            </div>
        </>
    );
}

NgpSmtpGuard.propTypes = {
    children: node.isRequired,
};
